<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/solid'
import { useI18n } from 'vue-i18n'
import { useParams } from '@/composables/useParams'

/**
 * Use the current parameters.
 */
const { set } = useParams()

/**
 * Translations.
 */
const { t } = useI18n()
</script>

<template>
    <button
        type="button"
        class="group flex cursor-pointer items-center gap-4 rounded-full rounded-r-none py-2 pl-3 pr-2 transition-colors duration-200 md:pl-6"
        @click="set()"
    >
        <span class="hidden lg:block">{{ t('close') }}</span>
        <XMarkIcon class="h-7 rounded-full border p-1" />
    </button>
</template>